export const workhuman = {
	title: "Workhuman",
	location: "Framingham, MA",
	description: "Building NLP solutions for internal and external clients. Focusing on uncovering langauge bias in work communications and how to improve work communication to be more inclusive.",
	role: "NLP Data Scientist"
}
export const sway = {
	title: "Sway AI",
	location: "Boston, MA",
	description: " Building machine learning models for various domains, Object Detection, Machine Translation, and Language Modeling. Domain of research includes Natural Language Processing and Cognitive Science.",
	role: "Senior Data Scientist",
}

export const nj = {
	title: "New Jersey Institute of Technology",
	location: "Newark, NJ",
	description: "Design and implement graph-based neural models for predicting electrical circuit efficiency with different typologies.",
	role: "Research Assistent",
}